import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'
import { useMapRefresh } from './context/use-map-refresh'

export const useReferencePolygons = (farmId) => {
  const [polygons, setPolygons] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { refreshTrigger } = useMapRefresh()

  useEffect(() => {
    async function fetchReferencePolygons() {
      if (!farmId) {
        setPolygons([])
        setLoading(false)
        setError(null)
        return
      }

      setLoading(true)
      setError(null)

      try {
        const { data, error: fetchError } = await supabaseGetter.referencePolygons.getByFarm(farmId)
        if (fetchError) throw fetchError

        const valid = (data || []).filter(
          p => p.points && Array.isArray(p.points) && p.points.length >= 3
        )
        setPolygons(valid)
      } catch (err) {
        console.error('Error fetching reference polygons:', err)
        setError(err.message)
        setPolygons([])
      } finally {
        setLoading(false)
      }
    }

    fetchReferencePolygons()
  }, [farmId, refreshTrigger])

  return {
    polygons,
    loading,
    error,
    invalidate: supabaseGetter.referencePolygons.invalidate
  }
}
